// extracted by mini-css-extract-plugin
export default {"circle":"Icon_circle__ywgkm","icon":"Icon_icon__KQAwS"};